import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Col, Row } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import EntityStateUpdater from 'component/EntityStateUpdater';

import Loader from 'components/layout/Loader';
import Data from 'components/Data';
import Entity from 'components/Entity';

import FormInput from 'components/forms/FormInput';
import FormErrors from 'components/forms/FormErrors';

import { entityMetaMapping } from 'js/constants';

class AllowedDomainForm extends EntityStateUpdater {
  constructor(props) {

    if (props.formStatus) {
      props.formStatus.response = null;
      props.formStatus.hasError = false;
      props.formStatus.errors = [];
    }

    super(props);

    this.state = {
      entityLoaded: false,
      entityChanged: false,
      allowedDomain: props.allowedDomain,
    };

    this.entity = new Entity();
    this.entity.setData(props.allowedDomain || {});
    if (props.meta[entityMetaMapping.allowedDomain] !== undefined && !props.meta[entityMetaMapping.allowedDomain].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.allowedDomain);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = () => {
    const { meta, formStatus, closeModal } = this.props;

    if (formStatus && !formStatus.pending && formStatus.response !== null) {
      console.log(formStatus, formStatus.pending, formStatus.response, typeof formStatus.response !== null);
      closeModal();
    }

    if (
      meta[entityMetaMapping.allowedDomain] !== undefined &&
      !meta[entityMetaMapping.allowedDomain].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.allowedDomain);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  formSubmit = e => {
    e.preventDefault();

    this.setState(
      prevState => ({ entity: prevState.entity.validate() }),
      () => {
        const { onSubmit } = this.props;
        const { entity } = this.state;

        if (entity.isValid) {
          if (this.props.type === 'new') {
            onSubmit({ ...entity.processedData });
          } else {
            onSubmit(this.props.allowedDomain.id, { ...entity.processedData });
          }
        }
      },
    );
  };

  render() {
    const {
      intl: { messages },
      formStatus,
      type,
    } = this.props;
    const { entity, entityChanged, entityLoaded } = this.state;
    const disabled = formStatus.pending;

    return (
      <Row>
        <Data dataName="allowedDomain" /> {/* fetch meta data */}
        <Col xs={12}>
          <FormErrors formStatus={formStatus} />

          {entityLoaded ? (
            <form method="post" onSubmit={this.formSubmit}>
              <div class="panel panel-transparent">
                <div class="form-group-attached">
                  <FormInput
                    name="domainName"
                    label={messages.allowed_domains_domain_name}
                    value={entity.getDomainName()}
                    meta={entity.getDomainNameMetaInformation()}
                    validation={entity.getDomainNameValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled || type !== 'new'}
                    required
                  />
                  <div class="form-group form-group-default">
                    <div className="checkbox check-success">
                      <input
                        id="check_default_src"
                        disabled={disabled}
                        name="defaultSrc"
                        type="checkbox"
                        value={!!entity.getDefaultSrc()}
                        checked={!!entity.getDefaultSrc()}
                        onChange={(event) => this.updateEntity('defaultSrc', event.target.checked)}
                      />
                      <label htmlFor="check_default_src"
                             style={{ paddingLeft: 0, marginRight: 0 }}>{messages.allowed_domains_default_src}</label>
                    </div>
                  </div>
                  <div class="form-group form-group-default">
                    <div className="checkbox check-success">
                      <input
                        id={`check_script_src`}
                        disabled={disabled}
                        name="scriptSrc"
                        type="checkbox"
                        value
                        checked={!!entity.getScriptSrc()}
                        onChange={(event) => this.updateEntity('scriptSrc', event.target.checked)}
                      />
                      <label htmlFor={`check_script_src`}
                             style={{ paddingLeft: 0, marginRight: 0 }}>{messages.allowed_domains_script_src}</label>
                    </div>
                  </div>
                  <div class="form-group form-group-default">
                    <div className="checkbox check-success">
                      <input
                        id={`check_connect_src`}
                        disabled={disabled}
                        name="connectSrc"
                        type="checkbox"
                        value
                        checked={!!entity.getConnectSrc()}
                        onChange={(event) => this.updateEntity('connectSrc', event.target.checked)}
                      />
                      <label htmlFor={`check_connect_src`}
                             style={{ paddingLeft: 0, marginRight: 0 }}>{messages.allowed_domains_connect_src}</label>
                    </div>
                  </div>
                  <div class="form-group form-group-default">
                    <div className="checkbox check-success">
                      <input
                        id={`check_style_src`}
                        disabled={disabled}
                        name="styleSrc"
                        type="checkbox"
                        value
                        checked={!!entity.getStyleSrc()}
                        onChange={(event) => this.updateEntity('styleSrc', event.target.checked)}
                      />
                      <label htmlFor={`check_style_src`}
                             style={{ paddingLeft: 0, marginRight: 0 }}>{messages.allowed_domains_style_src}</label>
                    </div>
                  </div>
                  <div class="form-group form-group-default">
                    <div className="checkbox check-success">
                      <input
                        id={`check_font_src`}
                        disabled={disabled}
                        name="fontSrc"
                        type="checkbox"
                        value
                        checked={!!entity.getFontSrc()}
                        onChange={(event) => this.updateEntity('fontSrc', event.target.checked)}
                      />
                      <label htmlFor={`check_font_src`}
                             style={{ paddingLeft: 0, marginRight: 0 }}>{messages.allowed_domains_font_src}</label>
                    </div>
                  </div>
                  <div class="form-group form-group-default">
                    <div className="checkbox check-success">
                      <input
                        id={`check_frame_src`}
                        disabled={disabled}
                        name="frameSrc"
                        type="checkbox"
                        value
                        checked={!!entity.getFrameSrc()}
                        onChange={(event) => this.updateEntity('frameSrc', event.target.checked)}
                      />
                      <label htmlFor={`check_frame_src`}
                             style={{ paddingLeft: 0, marginRight: 0 }}>{messages.allowed_domains_frame_src}</label>
                    </div>
                  </div>
                </div>

                <div class="text-right m-t-15">
                  <Button bsSize="lg" disabled={disabled} type="submit" bsStyle={entityChanged ? 'primary' : 'default'}>
                    <i class={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                    {messages.save}
                  </Button>
                </div>
              </div>
            </form>
          ) : (
            <Loader />
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    meta: state.entityMeta,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(AllowedDomainForm)));
